<template>
    <el-dialog :visible.sync="isAdd" title="编辑" width="580px" append-to-body destroy-on-close
        :close-on-press-escape="false" :close-on-click-modal="false" @close="$emit('close')">
        <el-form ref="modelForm" :model="modelForm" label-width="110px" class="room_type_container"
            style="margin: 0 20px" size="small" :rules="modelFormRules">
            <el-form-item label="房间类型" prop="roomTypeId">
                <el-select v-model="modelForm.roomTypeId" placeholder="请选择房间类型" clearable style="width: 250px">
                    <el-option v-for="item in roomTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="楼层" prop="floor">
                <el-select v-model="modelForm.floor" placeholder="请选择楼层" clearable style="width: 250px">
                    <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.floorName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房间号" prop="roomNo">
                <el-input type="text" v-model="modelForm.roomNo" placeholder="请输入房型名称" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="modelForm.status" style="width: 250px">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="3">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="预定说明" prop="name">
                <el-input type="textarea" v-model="modelForm.name" placeholder="请输入房型名称" style="width: 250px"></el-input>
            </el-form-item> -->
        </el-form>
        <div class="footer" style="margin: 0 20px; text-align: right">
            <el-button type="text" @click="isAdd = false">取消</el-button>
            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
        </div>
    </el-dialog>
</template>


<script>
export default {
    props: {
        isRoom: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        roomId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isAdd: false,
            modelForm: {
                roomTypeId: "",
                floor: "",
                roomNo: "",
                status: 1
            },
            modelFormRules: {
                roomTypeId: [{ required: true, message: "请选择房型", trigger: "blur" }],
                floor: [{ required: true, message: "请选择楼层", trigger: "blur" }],
                roomNo: [{ required: true, message: "请输入房间号", trigger: "blur" }],
                floorName: [{ required: true, message: "请输入楼层名称", trigger: "blur" }],
            },
            submitLoading: false,
            floorList: [],
            roomTypeList: []
        }
    },
    watch: {
        isRoom(newVal) {
            this.isAdd = !!newVal;
            if (!!newVal) {
                this.getRoomInfo();
                this.getFloorList();
                this.getRoomTypeList();
            }
        },
    },
    methods: {
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                 
                    this.postRequest("/api/room/modify", this.modelForm)
                    .then((res) => {
                        this.submitLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success(data.msg);
                            this.$emit('confirm')
                        }
                    })
                    .catch(() => {
                        this.submitLoading = false;
                    });
                }
            });
        },
        getRoomInfo() {
            this.getRequest(`/api/room/get/${this.roomId}`).then((res) => {
                let data = res.data;
                if (data.code == 200) {
                    this.modelForm = data.data;
                }
            });
        },
        getFloorList() {
            this.getRequest(`/floor/getHotelFloor?hotelId=${this.hotelId}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.floorList = data.data;
                }
            })
        },
        getRoomTypeList() {
            this.getRequest(`/api/roomType/getByHotelId?hotelId=${this.hotelId}`)
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.roomTypeList = data.data;
                }
            })
        }
    },
}
</script>